export enum ExceptionType {
  EXTRA_SESSION = 'EXTRA_SESSION',
  EXPIRY_EXTENSION = 'EXPIRY_EXTENSION',
  RESCHEDULE = 'RESCHEDULE',
  MANUAL_ADJUSTMENT = 'MANUAL_ADJUSTMENT',
  SYSTEM_OVERRIDE = 'SYSTEM_OVERRIDE',
}

export enum ExceptionSource {
  SYSTEM = 'SYSTEM',
  ADMIN_PANEL = 'ADMIN_PANEL',
  API = 'API',
}

export interface ExceptionLog {
  id: string;
  user_id: string;
  internal_user_id?: string | null;
  exception_type: ExceptionType;
  bundle_usage_id?: string | null;
  session_id?: string | null;
  old_value?: Record<string, any> | null;
  new_value?: Record<string, any> | null;
  reason?: string | null;
  meta?: Record<string, any> | null;
  source: ExceptionSource;
  created_at: string;
  updated_at: string;
}

